import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SchedulerTraceState, SessionStatus, SessionStatusDescription } from '../../enums/generated.enums';

@Component({
  selector: 'shared-status-info',
  templateUrl: './status-info.component.html',
  styleUrls: ['./status-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StatusInfoComponent {
  private _status: SchedulerTraceState | SessionStatus;
  iconKey: string;
  color: string;

  @Input() statusTooltip: string;
  @Input() tooltipOnly = false;

  @Input() set status(status: SchedulerTraceState | SessionStatus) {
    this._status = status;
    switch (status) {
      case SessionStatus.Pending:
      case SessionStatus.VirtualPending:
        this.iconKey = 'time';
        this.color = 'default';
        break;
      case SessionStatus.Running:
      case SessionStatus.Resumed:
        this.iconKey = 'uploaded';
        this.color = 'success';
        break;
      case SchedulerTraceState.ActionSuccessful:
      case SessionStatus.Completed:
        this.iconKey = 'done-circle';
        this.color = 'success';
        break;
      case SchedulerTraceState.ActionFailed:
      case SchedulerTraceState.ConditionEvaluationFailed:
      case SessionStatus.NotResponding:
      case SessionStatus.Terminated:
      case SessionStatus.Terminating:
        this.iconKey = 'error-circle';
        this.color = 'danger';
        break;
      case SessionStatus.Archived:
        this.iconKey = 'canceled-circle';
        this.color = 'danger';
        break;
      case SessionStatus.Stopped:
      case SessionStatus.Stopping:
      case SessionStatus.Warning:
        this.iconKey = 'error-circle';
        this.color = 'warning';
        break;
      case SessionStatus.Debugging:
      case SessionStatus.Suspended:
        this.iconKey = 'time';
        this.color = 'warning';
        break;
      case SessionStatus.VirtualCanceling:
        this.iconKey = 'close';
        this.color = 'gray';
        break;
      default:
        this.iconKey = 'unknown';
        this.color = 'default';
        break;
    }
  }

  get status(): SchedulerTraceState | SessionStatus {
    return this._status;
  }

  get statusText(): string {
    switch (this.status) {
      case SchedulerTraceState.ActionSuccessful:
        return 'Success';
      case SchedulerTraceState.ActionFailed:
      case SchedulerTraceState.ConditionEvaluationFailed:
        return 'Failed';
      default:
        return SessionStatusDescription.get(this.status) ?? '';
    }
  }

  get tooltip(): string {
    return this.statusTooltip ?? this.statusText;
  }

  constructor() {}
}
